import Vue from 'vue'
import  Router from 'vue-router'

Vue.use(Router)

const routes = [
    {
      path: '/',
      component: () => import('@/views/dashboard/Index'),
      redirect: '/paginas/viajes',
      meta:{requiresAuth: true},
      children: [
        // Dashboard
        {
          name: 'Dashboard',
          path: '',
          component: () => import('@/views/dashboard/Dashboard'),
        },
        // Pages
        {
          name: 'Solicitudes',
          path: 'paginas/viajes',
          component: () => import('@/views/dashboard/pages/Viajes'),
        },
        {
          name:'perfil',
          path: '/perfil-empresa',
          component: () => import('@/views/dashboard/pages/PerfilProveedor'),
        },
        {
          name:'Videos',
          path: 'paginas/videos',
          component: () => import('@/views/dashboard/pages/Tutorial'),
        },
        {
          name:'Movimientos',
          path: 'paginas/movimientos',
          component: () => import('@/views/dashboard/pages/Movimientos'),
        },
        {
          name:'Complementos',
          path: 'complementos',
          component: () => import('@/views/dashboard/pages/ComplementosPago'),
        },
      ],
    },
    {
      name:'login',
      path: '/login',
      component: () => import('@/views/dashboard/pages/Login'),
    },
    {
      name:'recuperar',
      path: '/recuperar-password',
      component: () => import('@/views/dashboard/pages/RecuperarPass'),
  }
]

    const router = new Router({
      mode: 'hash',
      base: process.env.BASE_URL,
      routes: routes
    })

export default router

router.beforeEach((to, from, next) => {

    if ((to.path !== '/login' && to.path !== 'login' && to.path !== '/Login' && to.path !== 'Login') && !localStorage.getItem('login')) {
    next({ path: '/login' })
    } else if ((to.path === '/login' || to.path === 'login' || to.path === '/Login' || to.path === 'Login') && localStorage.getItem('login')) {
      next({ path: '/paginas/viajes' })
    } else {
      next()
    }

})
